var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('small',[_vm._v("Cluster date")]),_c('FilterTypeDate',{attrs:{"fromType":"clusterDateFrom","toType":"clusterDateTo"}}),_c('small',[_vm._v("Cluster end date")]),_c('FilterTypeDate',{attrs:{"fromType":"clusterEndDateFrom","toType":"clusterEndDateTo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }